import * as React from "react";
import "./styles.scss";

interface WideCardProps {
    children: JSX.Element | JSX.Element[];
}

const WideCard = (props: WideCardProps) => {
    return <div className="wide-card">{props.children}</div>;
};

export default WideCard;
